import React from 'react';
import type { InputProps as AntInputProps, InputRef } from 'antd';
import { Input as AntInput } from 'antd';

export function Input(props: AntInputProps): JSX.Element {
  return <AntInput {...props} />;
}

// AntdInput loses the ability to use ref once used with styled components, so we need to forward it.
// This wrapper is still consumed by the date-range picker.
export const InputReactWrapper = React.forwardRef<InputRef, AntInputProps>((props: AntInputProps, ref) => {
  return <AntInput ref={ref} {...props} />;
});

InputReactWrapper.displayName = 'InputReactWrapper';

Input.Password = AntInput.Password;
